/**
 * Admin tokens in localStorage — httpOnly cookies are rejected when the admin
 * UI is on a different site than the API (e.g. http://IP:3043 → api.coinmbx.com,
 * SameSite=Lax). Bearer via X-Admin-Authorization is the session that actually
 * works in that setup. localStorage (not sessionStorage) survives refresh + new tabs.
 */

const ACCESS_KEY = "coinmbx_admin_access_token";
const REFRESH_KEY = "coinmbx_admin_refresh_token";

function store() {
  try {
    return window.localStorage;
  } catch {
    return window.sessionStorage;
  }
}

function read(key) {
  try {
    return localStorage.getItem(key) || sessionStorage.getItem(key) || null;
  } catch {
    return null;
  }
}

export function setAdminTokens(access, refresh) {
  const s = store();
  if (access) s.setItem(ACCESS_KEY, access);
  if (refresh) s.setItem(REFRESH_KEY, refresh);
  try {
    sessionStorage.removeItem(ACCESS_KEY);
    sessionStorage.removeItem(REFRESH_KEY);
  } catch {
    /* ignore */
  }
}

export function getAdminAccessToken() {
  return read(ACCESS_KEY);
}

export function getAdminRefreshToken() {
  return read(REFRESH_KEY);
}

export function clearAdminTokens() {
  try {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
    sessionStorage.removeItem(ACCESS_KEY);
    sessionStorage.removeItem(REFRESH_KEY);
  } catch {
    /* ignore */
  }
}

export function hasAdminSession() {
  return Boolean(getAdminAccessToken() || getAdminRefreshToken());
}
